import { connect } from 'react-redux';
import { setAdmin } from 'redux/actions/layoutActions';
import MainLayout from './AuthLayout';

const mapStateToProps = ({ layout: { locale, userToken, userData } }) => ({ locale, userToken, userData });

export default connect(mapStateToProps, { setAdmin })(MainLayout);
